import { Component } from "react";
import { Navigate } from "react-router-dom";

import { CommonService } from "../js_modules/CommonService";

import { SellToWebAdminPageComponent } from "../common/selltowebpage/SellToWebAdminPageComponent";
import { SellToWebInputComponent } from "../common/selltowebinput/SellToWebInputComponent"

import { XSRFTest3QueryComponent } from "./XSRFTest3QueryComponent";

export class XSRFTest3RouteComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadingData: false,
            token: "",
            vin: "Test1",
            redirectTo: ""
        };

        this.onChange = this.onChange.bind(this);
        this.onGetPageInfo = this.onGetPageInfo.bind(this);
        this.onActionWithValidation = this.onActionWithValidation.bind(this);
        this.onActionWithoutValidation = this.onActionWithoutValidation.bind(this);
        this.onGoToXSRF1 = this.onGoToXSRF1.bind(this);
        this.onGoToXSRF2 = this.onGoToXSRF2.bind(this);
    }

    pageTitle = "XSRF Test 3";

    componentDidMount() {
        try {
            this.props.onPageLoad({ pageTitle: this.pageTitle });
            this.setState({ token: CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS") });
        }
        catch (error) {
            console.logError(error, "XSRFTest3RouteComponent", "componentDidMount");
        }
    }

    onGetPageInfo() {
        try {
            this.setState({ isLoadingData: true });
            this.props.applicationInsights.trackTrace({ message: "XSRFTest3RouteComponent/onGetPageInfo", properties: { logon: this.props.logon } });
            fetch("/XSRFTest3/GetPageInfo", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;",
                    "X-XSRF-TOKEN-ACQUIRECARS": this.state.token
                },
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        token: CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS"),
                        isLoadingData: false
                    });
                })
                .catch(notOKResponse => {
                    this.props.onShowAlert("danger", { message: "Get Page Info Failed." });
                    this.setState({
                        isLoadingData: false
                    });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/XSRFTest3/ValidateWithKey", ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "XSRFTest3RouteComponent", "onGetPageInfo");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "XSRFTest3RouteComponent", "onGetPageInfo");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "XSRFTest3RouteComponent", "onGetPageInfo");
        }
    }

    onChange(id, value) {
        try {
            this.setState({ [id]: value })
        }
        catch (error) {
            console.logError(error, "XSRFTest3RouteComponent", "onChange");
        }
    }

    onActionWithValidation() {
        try {
            this.setState({ isLoadingData: true });
            this.props.applicationInsights.trackTrace({ message: "XSRFTest3RouteComponent/onActionWithValidation", properties: { logon: this.props.logon } });

            let inputData = {
                vin: this.state.vin
            };
            fetch("/XSRFTest3/ActionWithValidation", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;",
                    "X-XSRF-TOKEN-ACQUIRECARS": this.state.token
                },
                credentials: "same-origin",
                body: JSON.stringify(inputData)
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    this.setState({
                        token: CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS"),
                        isLoadingData: false
                    });
                    if (parsedResponse.success) {
                        this.props.onShowAlert("success", { message: "Anti-Forgery Validation Successfull.!" }, 4000);
                    }
                    else {
                        this.props.onShowAlert("danger", { message: "Anti-Forgery Validation Failed." });
                    }
                    this.setState({ isLoadingData: false });
                })
                .catch(notOKResponse => {
                    this.props.onShowAlert("danger", { message: "Anti-Forgery Validation Failed." });
                    this.setState({
                        isLoadingData: false
                    });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/XSRFTest3/ActionWithValidation", ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "XSRFTest3RouteComponent", "onActionWithValidation");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "XSRFTest3RouteComponent", "onActionWithValidation");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "XSRFTest3RouteComponent", "onActionWithValidation");
        }
    }

    onActionWithoutValidation() {
        try {
            this.setState({ isLoadingData: true });
            this.props.applicationInsights.trackTrace({ message: "XSRFTest3RouteComponent/onActionWithoutValidation", properties: { logon: this.props.logon } });
            fetch("/XSRFTest3/ActionWithoutValidation", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json; charset=utf-8;"
                },
                credentials: "same-origin"
            })
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    if (parsedResponse.success) {
                        this.props.onShowAlert("success", { message: "Anti-Forgery Validation Skipped.!" }, 4000);
                    }
                    else {
                        this.props.onShowAlert("danger", { message: "Anti-Forgery Validation Skip Failed." });
                    }
                    this.setState({ isLoadingData: false });
                })
                .catch(notOKResponse => {
                    this.props.onShowAlert("danger", { message: "Anti-Forgery Validation Skipped." });
                    this.setState({
                        isLoadingData: false
                    });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/XSRFTest3/ActionWithoutValidation", ...parsedError, logon: this.props.logon } });
                                console.logError(parsedError, "XSRFTest3RouteComponent", "onActionWithoutValidation");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "XSRFTest3RouteComponent", "onActionWithoutValidation");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "XSRFTest3RouteComponent", "onActionWithoutValidation");
        }
    }

    onGoToXSRF1() {
        try {
            this.setState({
                redirectTo: "/Demo/XSRFTest1"
            });
        }
        catch (error) {
            console.logError(error, "XSRFTest3RouteComponent", "onGoToXSRF1");
        }
    }

    onGoToXSRF2() {
        try {
            this.setState({
                redirectTo: "/Demo/XSRFTest2"
            });
        }
        catch (error) {
            console.logError(error, "XSRFTest3RouteComponent", "onGoToXSRF2");
        }
    }

    render() {
        if (this.state.redirectTo) {
            console.log("Redirecting to ", this.state.redirectTo);
            return <Navigate to={this.state.redirectTo} />;
        }
        return <SellToWebAdminPageComponent>
            <div className="admin-flex-item admin-body">
                <div className="d-flex flex-column admin-fill-content">
                    <XSRFTest3QueryComponent isLoadingData={this.state.isLoadingData} onShowAlert={this.props.onShowAlert} applicationInsights={this.props.applicationInsights}
                        onGetPageInfo={this.onGetPageInfo} onActionWithValidation={this.onActionWithValidation} onActionWithoutValidation={this.onActionWithoutValidation}
                        onGoToXSRF1={this.onGoToXSRF1} onGoToXSRF2={this.onGoToXSRF2} />
                    <br />
                    <div className="card">
                        <div className="card-block" style={{ "padding": "10px" }}>
                            <strong>Page Cookies:</strong><br />
                            {decodeURIComponent(document.cookie)}<br /><br />
                            <strong>XSRF Token:</strong><br />
                            {CommonService.getCookie("XSRF-TOKEN-ACQUIRECARS")}<br /><br />
                            <SellToWebInputComponent id="token" value={this.state.token} label="Token" onTextChange={this.onChange} />
                            <SellToWebInputComponent id="vin" value={this.state.vin} label="VIN" onTextChange={this.onChange} />
                        </div>
                    </div>
                </div>
            </div>
        </SellToWebAdminPageComponent>;
    }
}